<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">이용가이드</h1>
      <p class="page-tit">이용가이드</p>
    </section>
    <!-- 이용가이드 -->
    <Tabs
      :tabs="['신고자 접수 절차', '패치 접수 절차']"
      v-model="selectedTab"
      role="tablist"
    />
    <!-- 신고자 접수 절차 -->
    <div
      v-show="selectedTab === 0"
      id="tabpanel-0"
      role="tabpanel"
      :aria-labelledby="'tab-0'"
      class="guide"
    >
      <h2 class="section-title">신고자 접수 절차</h2>
      <ul>
        <li class="pc-only">
          <img
            src="@/assets/img/intro/img_consent_guide.png"
            alt=""
            class="light-only"
          />
          <img
            src="@/assets/img/intro/img_consent_guide_dark.png"
            alt=""
            class="dark-only"
          />
        </li>
        <li class="tb-only layout-flex-row type-col--mobile">
          <img
            src="@/assets/img/intro/img_consent_guide_tb1.png"
            class="light-only"
            alt=""
          />
          <img
            src="@/assets/img/intro/img_consent_guide_tb2.png"
            class="light-only"
            alt=""
          />
          <img
            src="@/assets/img/intro/img_consent_guide_tb1_dark.png"
            class="dark-only"
            alt=""
          />
          <img
            src="@/assets/img/intro/img_consent_guide_tb2_dark.png"
            class="dark-only"
            alt=""
          />
        </li>
        <li class="m-only layout-flex-row type-col--mobile">
          <img
            src="@/assets/img/intro/img_consent_guide_m1.png"
            class="light-only"
            alt=""
          />
          <img
            src="@/assets/img/intro/img_consent_guide_m2.png"
            class="light-only"
            alt=""
          />
          <img
            src="@/assets/img/intro/img_consent_guide_m1_dark.png"
            class="dark-only"
            alt=""
          />
          <img
            src="@/assets/img/intro/img_consent_guide_m2_dark.png"
            class="dark-only"
            alt=""
          />
        </li>
      </ul>
      <div class="text-hidden">
        <h1>신고자 접수 절차</h1>
        <ul>
          <li>확인사항 탭</li>
          <li>1. 확인사항을 선택해주세요</li>
          <li>2. 동의 여부를 확인하시고 동의버튼을 선택해주세요</li>
          <li>3. 다음 버튼을 클릭해주세요</li>
          <li>취약점 정보 탭</li>
          <li>4. 취약점 정보를 선택하시고 모든 정보를 입력해주세요</li>
          <li>5. 접수 버튼을 클릭해주세요</li>
        </ul>
      </div>
    </div>
    <!-- 패치 접수 절차 -->
    <div
      v-show="selectedTab === 1"
      id="tabpanel-1"
      role="tabpanel"
      :aria-labelledby="'tab-1'"
      class="guide"
    >
      <h2 class="section-title">패치 접수 절차</h2>
      <figure class="layout-flex-row type--center" aria-hidden="true">
        <picture class="light-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/intro/img_patch_submit_m.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/intro/img_patch_submit_tb.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img
            src="@/assets/img/intro/img_patch_submit.png"
            alt=""
            class="light-only"
          />
        </picture>
        <picture class="dark-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/intro/img_patch_submit_m_dark.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/intro/img_patch_submit_tb_dark.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/intro/img_patch_submit_dark.png" alt="" />
        </picture>
        <div class="text-hidden">
          <h1>패치 접수 절차</h1>
          <ul>
            <li>패치 내용 작성 탭</li>
            <li>1. 패치 내용 작성을 선택하시고 모든 정보를 입력해주세요</li>
            <li>2. 접수 버튼을 클릭해주세요</li>
          </ul>
        </div>
      </figure>
    </div>
    <!-- 검색 방법 -->
    <div
      v-show="selectedTab === 2"
      id="tabpanel-2"
      role="tabpanel"
      :aria-labelledby="'tab-2'"
      class="guide"
    >
      <h2 class="section-title">검색 방법</h2>
      <figure class="layout-flex-row type--center" aria-hidden="true">
        <picture class="light-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/intro/img_search_guide_m.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/intro/img_search_guide_tb.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/intro/img_search_guide.png" alt="" />
        </picture>
        <picture class="dark-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/intro/img_search_guide_m_dark.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/intro/img_search_guide_tb_dark.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/intro/img_search_guide_dark.png" alt="" />
        </picture>
        <div class="text-hidden">
          <h1>검색 방법</h1>
          <ul>
            <li>상단 검색바</li>
            <li>1. 상세보기 버튼을 클릭해주세요</li>
            <li>
              2. 키워드, 취약점 등록일, 업데이트 일로 취약점 검색이 가능합니다.
            </li>
            <li>3. 모든 정보를 입력하셨다면 검색 버튼을 클릭해주세요</li>
          </ul>
        </div>
      </figure>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Tabs from "@/component/Tabs.vue";
export default {
  components: {
    Tabs,
  },
  setup() {
    // data 정의
    const selectedTab = ref(0);
    return {
      selectedTab,
    };
  },
};
</script>
